import { render } from "./B2CPanelModule.vue?vue&type=template&id=125a0106&ts=true"
import script from "./B2CPanelModule.vue?vue&type=script&lang=ts"
export * from "./B2CPanelModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__